import { getAssert } from "../../utils/Safe";

/**
 * TODO - Add description.
 */
export default class FlumpTextureSymbol
{
    /**
     * @param {Phaser.Game} game - A reference to the currently running game.
     * @param {*} atlas - JSON object for the parent atlas.
     * @param {string} json - JSON object for the texture.
     */
    constructor(game, atlas, json)
    {
        /**
         * @type {Phaser.Game}
         */
        this.game = game;

        // Safely get these properties.
        let rect = getAssert([json, "rect"], "[FlumpTextureSymbol] Cannot find texture rect in json.");
        let x = getAssert([rect, 0], "[FlumpTextureSymbol] Cannot find rect x in json.");
        let y = getAssert([rect, 1], "[FlumpTextureSymbol] Cannot find rect y in json.");
        let width = getAssert([rect, 2], "[FlumpTextureSymbol] Cannot find rect with in json.");
        let height = getAssert([rect, 3], "[FlumpTextureSymbol] Cannot find rect height in json.");
        
        /**
         * @type {string} 
         */
        this.name = getAssert([json, "symbol"], "[FlumpTextureSymbol] Cannot find texture name.");
        /**
         * @type {*} 
         */
        this.rect = rect;  
        /**
         * @type {*} 
         */  
        this.origin = [
            getAssert([json, "origin", 0], "[FlumpTextureSymbol] Cannot find origin x."), 
            getAssert([json, "origin", 1], "[FlumpTextureSymbol] Cannot find origin y."), 
        ];

        /**
         * @type {Phaser.BitmapData} 
         */
        this.bitmap = game.make.bitmapData(width, height);        

        this.bitmap.copyRect(atlas, new Phaser.Rectangle(x, y, width, height), 0, 0);        
        game.cache.addBitmapData(this.name, this.bitmap);
    }
    
    /**
     * Cleans up the FlumpTextureSystem.
     */
    destroy()
    {
        this.game.cache.removeBitmapData(this.name);
        this.bitmap.destroy();
        this.bitmap = null;
        this.game = null;
    }
}